<template>
    <div class="w-100">
        <div class="input-style" style="float:left">
            <input
                type="text"
                ref="autocomplete"
                :disabled="inputDisabled"
                :placeholder="placeholder"
                :class="inputClass"
                class="input-float"
                :value="value"
                @input="updateValue($event.target.value)"
                @focus="onFocus"
                aria-label="input for location"
            />
            <div v-if="value" style="float:right" @click="clearValue">
                <svg-icon name="cross" style="transform: rotate(45deg)" class="mx-1" width="20"/>
            </div>
        </div>
        <div class="container w-100 m-0 p-0 ">
            <div v-if="showUserCurrentLocation" class="current-location-trigger d-flex align-items-center px-2 py-2 joined-inputs" @click="getCurrenLocation">
                <svg-icon name="location" class="mx-1" width="20"/> Use current location
            </div>
            <span class="form-error border-0 ml-2 w-100" v-if="showError">Cannot get the current location</span>
        </div>
    </div>
</template>
<script>
/* global google */
export default {
    name: 'auto-complete',
    props: {
        value: {
            type: String,
        },
        placeholder: {
            type: String,
            default: 'Enter value',
        },
        inputClass: {
            type: String,
            default: 'border-0 ml-1',
        },
        inputDisabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            location: '',
            currentAddress: null,
            inputFocused: false,
            showError: false,
        }
    },
    computed: {
        showUserCurrentLocation() {
            return !this.value && this.inputFocused
        },
    },
    created() {
        window.addEventListener('click', (e) => {
            if (!this.$el.contains(e.target)) {
                this.inputFocused = false
            }
        })
    },
    methods: {
        updateValue(value) {
            this.$emit('input', value)
        },
        clearValue() {
            this.$emit('input', null)
        },
        initAutocomplete() {
            const defaultBounds = new google.maps.LatLngBounds(
                /* Aberdeenshire bounds */
                new google.maps.LatLng(57.001210162832436, -2.9457858869887343),
                new google.maps.LatLng(57.72991624947179, -1.7592624494887343),
            )
            this.autocomplete = new google.maps.places.Autocomplete(
                (this.$refs.autocomplete),
                { componentRestrictions: { country: 'gb' }, bounds: defaultBounds },
            )
            this.autocomplete.addListener('place_changed', () => {
                this.$emit('input', this.$refs.autocomplete.value)
            })
        },
        getCurrenLocation() {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    this.getCurrentAddress({ lat: position.coords.latitude, lng: position.coords.longitude })
                },
                (error) => {
                    if (error) {
                        this.showError = true
                    }
                },
            )
        },
        getCurrentAddress(latLng) {
            const geocoder = new google.maps.Geocoder()
            geocoder.geocode({ location: latLng }, (results, status) => {
                if (status === 'OK') {
                    if (results[0]) {
                        this.currentAddress = results[0].formatted_address
                        this.$emit('input', this.currentAddress)
                    }
                } else {
                    this.showError = true
                }
            })
        },
        onFocus() {
            this.inputFocused = true
        },
    },
    mounted() {
        this.initAutocomplete()
    },
}
</script>
